<template>
  <data-table :service="ClientUserService"
              :entity="entity"
              :filters="filters"
              :columns="columns"
              ref="table">
    <template v-slot:name="{row}">
      <div class="flex items-center">
        <base-avatar :user="row"
                     :src="row.image">
        </base-avatar>
        <div class="ml-2 font-bold">
          {{row.given_name}} {{row.last_name}}
        </div>
      </div>
    </template>

    <template v-slot:client_name="{row}">
      <router-link :to="`/contacts/clients/${row.client_uuid}`">
        {{row.client_name}}
      </router-link>
    </template>

    <template v-slot:email="{row}">
      {{row.email}}
    </template>
    <template v-slot:created_at="{row}">
      {{$formatDate(row.created_at, FRIENDLY_DATETIME_FORMAT)}}
    </template>
    <template v-slot:active="{row}">
      <base-switch :value="row.active" @input="onToggleClientStatus(row, $event)"/>
    </template>
  </data-table>
</template>
<script>
  import ClientList from 'src/views/admin/contacts/clients/ClientList';
  import ClientUserService from 'src/services/ClientUserService';
  import entities from 'src/config/entities'
  import { FRIENDLY_DATETIME_FORMAT } from 'src/config/dateUtils'

  export default {
    name: 'user-details-overview',
    components: {
      ClientList
    },
    data() {
      return {
        ClientUserService,
        entity: entities.CLIENT_USER,
        FRIENDLY_DATETIME_FORMAT
      }
    },
    computed:{
      columns() {
        return [
          {
            prop: 'name',
            label: this.$t('user.list.labels.name'),
            minWidth: '150px',
            sortable: true
          },
          {
            prop: 'client_name',
            label: this.$t('generic.client'),
            minWidth: '150px',
            sortable: true
          },
          {
            prop: 'email',
            label: this.$t('user.list.labels.email'),
            minWidth: '180px',
            sortable: true
          },
          {
            prop: 'created_at',
            label: this.$t('generic.createdAt'),
            minWidth: '170px',
            sortable: true,
            mobile: false
          },
          {
            prop: 'active',
            label: this.$t('generic.active'),
            minWidth: '170px',
            sortable: true,
            mobile: true
          },
        ]
      },
      user() {
        return this.$store.getters['user/userInfo']
      },
      filters() {
        return [{
          key: 'match[user_uuid]',
          value: this.$route.params.id || this.user.uuid
        }]
      }
    },
    methods: {
      onFetchData ({total}) {
        this.$store.commit('user/SET_CLIENT_COUNT', total);
      },
      async onToggleClientStatus(row, active) {
        const prevValue = row.active
        try {
          this.$set(row, 'active', active)
          await ClientUserService.update(row.uuid, row)
        } catch (err) {
          this.$set(row, 'active', prevValue)
        }
      }

    }
  }
</script>
<style>
</style>
